/** Default values applied when not explicitly set by the builder. */
export const DEFAULTS = {
  bufferSymbols: 1 as number,
  symbolGap: { x: 0 as number, y: 0 as number },
  initialSpeed: 'normal' as string,
  maxPoolPerKey: 20 as number,
  zIndexStep: 100 as number,
};
